module.exports = __webpack_public_path__ + "static/media/0.75f720dd.mp4";